import styled from 'styled-components';

export const LoginHeader = styled.div`
      height: 100vh;
      width: 100vw;
      background-color: rgb(240, 245, 241) !important;
`;
